import React from 'react';
import useGlobals from '../../../../../../Hooks/useGlobals';
import JsonInputField from '../../../../../Utility/JsonInputField/JsonInputField';

interface OpenApiSpecSectionProps {
    openApiSpec: string;
    onSpecChange: (spec: string) => void;
    errors: Record<string, string>;
}

const OpenApiSpecSection: React.FC<OpenApiSpecSectionProps> = ({ openApiSpec, onSpecChange, errors }) => {
    const { i18n } = useGlobals();

    return (
        <div>
            <div className="my-4">
                <h4>{i18n.translate({ id: 'form.specification.title', sourceName: 'OpenAPI' })}</h4>
            </div>

            <div>
                <JsonInputField
                    label={i18n.translate({ id: 'form.spec.label', sourceName: 'OpenAPI' })}
                    value={openApiSpec}
                    onChange={onSpecChange}
                    placeholder={i18n.translate({ id: 'form.spec.placeholder', sourceName: 'OpenAPI' })}
                    minRows={10}
                    maxRows={25}
                    className="mb-0"
                />
                {errors.openApiSpec && <p className="text-red-500 text-sm mt-1">{errors.openApiSpec}</p>}
            </div>
        </div>
    );
};

export default OpenApiSpecSection;
